import * as React from "react";

export const Office = () => (
  <svg width="16" height="15" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.36092 0C3.12504 0 2.18496 1.10973 2.38813 2.3288L3 6H9L9.61187 2.3288C9.81504 1.10973 8.87496 0 7.63908 0H4.36092ZM1 10H2H5V12H2L2 14H5H7H10V12H7V10H10H11H12V6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6V8H2V6C2 5.44772 1.55228 5 1 5C0.447715 5 0 5.44772 0 6V10H1Z"
      fill="#737A8E"
    />
  </svg>
);
